import {useNavigate, useParams} from 'react-router-dom';
import {FeaturesEnum, MyAppointmentsEnum} from 'presentation/constants';
import {useBookedAppointmentConfirmation} from 'presentation/modules/booking/shared/hooks/useBookedAppointmentConfirmation';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';

export function useHealthConfirmationBooking() {
	const navigate = useNavigate();
	const {id: bookingId} = useParams();
	const {isEnabled: showNewConfirmationPage} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_NEW_CONFIRMATION_BOOKING_PAGE,
	);
	const {confirmedBookAppointment, refresh, appointmentsListLoading, appointmentsListError} =
		useBookedAppointmentConfirmation(bookingId);

	const goToMyAppointments = () => {
		navigate(MyAppointmentsEnum.MY_APPOINTMENTS);
	};

	return {
		goToMyAppointments,
		confirmedBookAppointment,
		appointmentsListLoading,
		appointmentsListError,
		refresh,
		showNewConfirmationPage,
	};
}
